/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { DEAL_TRANSITION_FORM } from '../resources/endPoint';

export const getDealDetails = (dealId) => {
  return {
    url: DEAL_TRANSITION_FORM + '?deal_id=' + dealId,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};